<template>
  <div style="overflow:hidden" > 
      <div>
        <b-form-input :autofocus="saveConfig.autofocus" v-model="searchSave" placeholder="Buscar afiliado agrupado"></b-form-input>
      </div>
      <table class="table table--save table-hover box-effect linear" v-if="dataPost[namePath].data.length>0">
        <thead>
          <tr>
            <th v-for="(items,index) in tableItems" :key="'theadSave'+index" v-if="hover>1">{{items.th}}</th>
            <th v-for="(items,index) in tableView" :key="'theadSave'+index" v-if="hover===1">{{items}}</th>
            <th class="text-center" style="width:120px"  v-if="hover>1">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items,index) in sortedTable()" :key="'dataPostSave'+index" :class="{'bg-grey': dataIndex[namePath]===index && dataIndex[namePath]!==false}">
            <td v-for="(items2,index2) in tableItems" :key="'tbodySave'+index2" v-if="hover>1 || tableView.includes(items2.th)">  
              <span v-for="(items3,index3) in items2.td" :key="'dataPostSpan'+index3">
                <span v-if="items2.tdtable===undefined">
                  <span v-if="items2.archivo">{{items[items3].length}} archivo seleccionado</span>
                  <span v-else>{{items[items3]}}</span>
                </span>  
                <span v-else>
                  <span v-for="(items4,index4) in items[items3]" :key="'array'+index4">
                    <span v-for="(items5,index5) in items2.tdtable" :key="'arraytd'+index5">
                      <span v-if="items5==='list' && items4.name_list!==''">
                        {{gettersDatalist(items4.name_list,items4.id_list)[0].label}}
                      </span>   
                      <span v-else>
                        {{items4[items5]}}
                      </span>                               
                    </span>
                  </span> 
                </span>                       
              </span>                    
            </td> 
            <td  v-if="hover>1">           
                <div  v-if="tableOptions.some(list => list==='editar')" class="text-primary" style="display:inline-block;padding-left:5px;padding-right:5px" >
                  <i class="material-icons option-btn" title="Editar" @click="editarDataPost(items.index)">create</i>
                </div>
                <div  v-if="tableOptions.some(list => list==='delete')" class="text-danger" style="display:inline-block;padding-left:5px;padding-right:5px" >
                  <i class="material-icons option-btn " title="Quitar" @click="spliceDataPost(items.index);resetDataIndex()">delete</i>
                </div> 
            </td>
          </tr>
        </tbody>
      </table>  
      <div>
        <b-row>
          <b-col>
            <b-button  
                v-if="dataPost[namePath].data.length>0 && saveConfig.capa===false" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
                @click="save(false);" 
                variant="success" 
                size="sm" 
                class="ml-2" 
                style="float: right"
                >  Guardar Agrupados</b-button> 
            <b-button  
                v-if="saveConfig.capa" 
                disabled 
                variant="success" 
                size="sm" 
                class="ml-2 sw-save-loading" 
                style="float: right"
                ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Guardar Agrupados</b-button> 
          </b-col>
        </b-row>
          

        </div>
        
      </div>   
      
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
function cleanParameter(value)
{
  if(value==null)
  {
    return '';
  }
  return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}
export default 
{
  name: 'tableSave',
  components: {
    
  },
  props: {   
    hover: {
      type: Number,
      default:  4,
    },
    tableItems: {
      type: Array,
      default: function(){
        return []
      }
    },
    tableOptions: {
      type: Array,
      default: function(){
        return ['editar','delete']
      }
    },
    tableView: {
      type: Array,
      default: function(){
        return []
      }
    },
    saveFtn: {
      type: String,
      default: 'tablePostGuardarFtn'
    }
  },
  data () {
    return { 
      searchSave: ''
    }
  },
  methods: {  
    async editarDataPost(index){  
      try { 
        await this.updateDataIndex({data: index})
        await this.postToForm()      
        await this.$emit('editar', false)
      } catch {
      } 
    },
    sortedTable() {
      if(this.dataPost[this.namePath].data.length>0){
        return this.deepCopyTable(this.dataPost[this.namePath].data)        
      }
      return []
    },  
    save(event)
    {     
      try { 
        this.$emit('save',{save: event, ftn: this.saveFtn})
      } catch {
      }        
    },  
  },
}
</script>
<style>
.table--save{
  min-width: 100%;
  border-collapse: collapse;
}
.table--save th{
  padding: 5px 8px;
  color: #444;
  font-weight: 500;
  border-top: none;
  background: #fcfcfc
}
.table--save td{
  padding: 8px;
  font-size:15px;
  color: rgb(85, 85, 85)
}
.bg-grey {
  background: rgba(0,0,0,.075)
}
</style>